export default __webpack_public_path__ + "static/media/backface.590c9ca0.vert";